module.exports =
`
# Advertise

MUZIK Air, the world's leading provider of classical music, providing the most convenient portal to classical music streaming. We provide opportunity in reaching classical music lovers through the large amount of delightful music, and being in contact with potential customers through our categorized playlists and articles. Please fill in the application below, and we will be in touch with you as soon as possible.

`
